import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_661e4868-d868-458c-86d6-2d10e12396a2/artifacts/tx0slj8p_ChatGPT_Image_15_de_mai._de_2026__13_56_39-removebg-preview.png";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF9F6] pb-8 relative">
      <img src={LOGO_URL} alt="" className="bg-watermark" />
      
      <div className="app-container relative z-10">
        <header className="flex items-center gap-4 p-4 pt-6">
          <Link to="/" className="p-2 text-[#8E8E93] hover:text-[#2E5C55]">
            <ArrowLeft className="h-6 w-6" />
          </Link>
          <h1 className="font-bold text-xl text-[#1C1C1E]" style={{ fontFamily: 'Syne, sans-serif' }}>
            Política de Privacidade
          </h1>
        </header>

        <div className="px-4 prose prose-sm max-w-none">
          <div className="card-base p-6 space-y-4 text-[#48484A]">
            <p className="text-sm text-[#8E8E93]">Última atualização: Janeiro de 2026</p>
            
            <p>
              A Ad Inteligencia Digital LTDA ("nós", "nosso") opera o aplicativo MapaPodal e está 
              comprometida em proteger a privacidade dos seus dados pessoais em conformidade com a 
              Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018).
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">1. Dados que Coletamos</h2>
            <p>Coletamos os seguintes tipos de dados:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Dados de cadastro:</strong> nome, email, senha (criptografada)</li>
              <li><strong>Imagens dos pés:</strong> fotos enviadas para análise reflexológica</li>
              <li><strong>Dados de uso:</strong> histórico de leituras, preferências</li>
              <li><strong>Dados de pagamento:</strong> processados pelo Mercado Pago (não armazenamos dados de cartão)</li>
            </ul>

            <h2 className="text-lg font-bold text-[#1C1C1E]">2. Finalidade do Tratamento</h2>
            <p>Utilizamos seus dados para:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Fornecer o serviço de análise reflexológica educacional</li>
              <li>Gerenciar sua conta e assinatura</li>
              <li>Melhorar nossos serviços e algoritmos</li>
              <li>Enviar comunicações relacionadas ao serviço</li>
              <li>Cumprir obrigações legais</li>
            </ul>

            <h2 className="text-lg font-bold text-[#1C1C1E]">3. Base Legal (LGPD)</h2>
            <p>O tratamento dos seus dados é baseado em:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Consentimento (Art. 7º, I):</strong> Para processamento de imagens e análises</li>
              <li><strong>Execução de contrato (Art. 7º, V):</strong> Para prestação dos serviços contratados</li>
              <li><strong>Legítimo interesse (Art. 7º, IX):</strong> Para melhoria dos serviços</li>
            </ul>

            <h2 className="text-lg font-bold text-[#1C1C1E]">4. Seus Direitos (LGPD)</h2>
            <p>Você tem direito a:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Acesso:</strong> Saber quais dados temos sobre você</li>
              <li><strong>Correção:</strong> Corrigir dados incompletos ou desatualizados</li>
              <li><strong>Portabilidade:</strong> Exportar seus dados em formato estruturado (JSON)</li>
              <li><strong>Eliminação:</strong> Solicitar a exclusão de todos os seus dados</li>
              <li><strong>Revogação:</strong> Retirar seu consentimento a qualquer momento</li>
              <li><strong>Oposição:</strong> Opor-se ao tratamento em determinadas situações</li>
            </ul>
            <p>
              Você pode exercer esses direitos diretamente no aplicativo (seção "Minha Conta" → "Privacidade") 
              ou entrando em contato conosco.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">5. Armazenamento e Segurança</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Dados são armazenados em servidores seguros no Brasil</li>
              <li>Senhas são criptografadas usando bcrypt</li>
              <li>Conexões são protegidas por HTTPS/TLS</li>
              <li>Acesso aos dados é restrito e auditado</li>
            </ul>

            <h2 className="text-lg font-bold text-[#1C1C1E]">6. Compartilhamento de Dados</h2>
            <p>Não vendemos seus dados. Podemos compartilhar com:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Processadores de pagamento:</strong> Mercado Pago (para transações)</li>
              <li><strong>Provedores de infraestrutura:</strong> Serviços de hospedagem</li>
              <li><strong>Autoridades:</strong> Quando exigido por lei</li>
            </ul>

            <h2 className="text-lg font-bold text-[#1C1C1E]">7. Retenção de Dados</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Dados de conta: Mantidos enquanto a conta estiver ativa</li>
              <li>Imagens: Armazenadas por até 1 ano após a leitura</li>
              <li>Dados de pagamento: Conforme exigências fiscais (5 anos)</li>
              <li>Logs de auditoria: Mantidos por 2 anos</li>
            </ul>

            <h2 className="text-lg font-bold text-[#1C1C1E]">8. Cookies e Tecnologias Similares</h2>
            <p>
              Utilizamos cookies essenciais para autenticação e funcionamento do serviço. 
              Consulte nossa Política de Cookies para mais informações.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">9. Transferência Internacional</h2>
            <p>
              Seus dados podem ser processados por provedores de IA localizados em outros países, 
              sempre com garantias adequadas de proteção conforme a LGPD.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">10. Encarregado de Dados (DPO)</h2>
            <p>
              Para questões relacionadas à privacidade e proteção de dados, entre em contato com 
              nosso Encarregado de Dados:
            </p>
            <p>
              Email: suporte@adinteligenciadigital.com.br
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">11. Alterações nesta Política</h2>
            <p>
              Podemos atualizar esta política periodicamente. Alterações significativas serão 
              comunicadas por email ou através do aplicativo.
            </p>

            <h2 className="text-lg font-bold text-[#1C1C1E]">12. Contato</h2>
            <p>
              <strong>Ad Inteligencia Digital LTDA</strong><br />
              CNPJ: 26.605.304/0001-76<br />
              Email: suporte@adinteligenciadigital.com.br<br />
              FAQ: faq@adinteligenciadigital.com.br
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
